import { useEffect } from "react";

export default function LogoutHelper() {
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.origin !== "https://ukvisajobs.com") return;

      if (event.data === "logout") {
        localStorage.removeItem("authToken");
        localStorage.removeItem("authTokenExpiry");
        // console.log("Auth token removed from React localStorage");
      }
    });
  }, []);

  return <div>Logout helper loaded...</div>;
}
